import { render, staticRenderFns } from "./ProcessPerformance.vue?vue&type=template&id=ae3f3072&scoped=true"
import script from "./ProcessPerformance.vue?vue&type=script&lang=js"
export * from "./ProcessPerformance.vue?vue&type=script&lang=js"
import style0 from "./ProcessPerformance.vue?vue&type=style&index=0&id=ae3f3072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3f3072",
  null
  
)

export default component.exports